import { FEED_TOPANTEPOST, feedTopAntePostType, TopAntePost } from 'lib/ssr/sport/top-ante-post/types';

export const feedTopAntePost = (payload: TopAntePost): feedTopAntePostType => ({
  type: FEED_TOPANTEPOST,
  payload,
});